exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3vlfy{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:19px;height:19px;border-radius:50%;color:#3899ec;font-size:11px;background:#ebf8ff;padding:0;outline:none;border:none}._3ot-d{position:fixed;top:0;left:0;z-index:10000;-ms-flex:0 0 auto;flex:0 0 auto;width:auto;min-height:0;color:#20455e;font-family:HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:14px;line-height:20px;font-weight:300;visibility:hidden;opacity:0;transition:visibility .2s,opacity .2s}._3ot-d.B9Q87{visibility:visible;opacity:1}._2Lac9{min-height:0;padding:15px 18px;white-space:pre-line}._3Pr33 button,._3Pr33 button:hover{background-color:transparent;border-color:transparent}._2_AjV{cursor:pointer}", ""]);

// exports
exports.locals = {
	"button": "_3vlfy",
	"popout": "_3ot-d",
	"positioned": "B9Q87",
	"popout-inner": "_2Lac9",
	"popoutInner": "_2Lac9",
	"transparent-icon-button": "_3Pr33",
	"transparentIconButton": "_3Pr33",
	"target": "_2_AjV"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/shared/components/tooltip/tooltip.styl
// module id = 578
// module chunks = app-settings/app-settings dashboard/dashboard widget/widget mobile/mobile mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals business-manager/video-library-page